export default __webpack_public_path__ + "static/media/kaminfeuer_web-xs@1x.0ec8f754.webp";